// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../../Factory/FieldsFactory';
import { MessageProcessorBase } from '../MessageProcessorBase';
import { DirectAlgorithmHeatmapMessage } from '@shared/utils/DirectMessages/Algorithm/DirectAlgorithmHeatmapMessage';
import { AlgorithmHeatmapRtDataGroup, AlgorithmHeatmapDelayDataGroup } from '../../Groups/GroupsImport';
import { HeatmapAlgorithmData } from '@shared/commons/cache/Algorithm/Heatmap/HeatmapAlgorithmData';
export class AlgorithmHeatmapMessageProcessor extends MessageProcessorBase {
    decode(fs) {
        const msg = new DirectAlgorithmHeatmapMessage();
        const ff = FieldsFactory;
        msg.AlgorithmId = fs.GetValue(ff.FIELD_ALGORITHM_ID);
        msg.AlgorithmName = fs.GetValue(ff.FIELD_ALGORITHM_NAME);
        msg.InstrumentListId = fs.GetValue(ff.FIELD_INSTRUMENT_LIST_ID);
        const rtGroups = fs.GetGroups(ff.ALGORITHM_HEATMAP_RT_GROUP, AlgorithmHeatmapRtDataGroup);
        for (const heatmapRtData of rtGroups) {
            const data = this.CreateHeatmapData(heatmapRtData, false);
            msg.HeatmapAlgorithmData.push(data);
        }
        const delayedGroups = fs.GetGroups(ff.ALGORITHM_HEATMAP_DELAY_DATA_GROUP, AlgorithmHeatmapDelayDataGroup);
        for (const heatmapDelayedtData of delayedGroups) {
            const data = this.CreateHeatmapData(heatmapDelayedtData, true);
            msg.HeatmapAlgorithmData.push(data);
        }
        return [msg];
    }
    CreateHeatmapData(heatmapGroup, isDelayed) {
        const data = new HeatmapAlgorithmData();
        data.IsDelayed = isDelayed;
        data.TradableId = heatmapGroup.TradableId;
        data.RouteId = heatmapGroup.RouteID;
        data.Change = heatmapGroup.Change;
        data.PercentChange = heatmapGroup.PercentChange;
        data.LastPrice = heatmapGroup.LastPrice;
        return data;
    }
}
